<template>
  <div>
    <global-header />
    <search-box />
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'app'
};
</script>

<style lang="scss">
/* bulma variable overrides */
$section-padding: 3rem 2rem;
$box-radius: 0;
$box-shadow: 0 0 4px 8px rgba(#000, 0.15);
$table-background-color: transparent;
$table-striped-row-even-background-color: rgba(0,0,0,.2);
$table-cell-border: none;
$table-cell-padding: .5em;

@import '~bulma/bulma';
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/typography.scss';
@import '@/assets/scss/global.scss';
</style>
